import { Avatar, AvatarBadge } from '@chakra-ui/react'
import React from 'react'

export type AvatarActivityProps = {
  idPerson?: string
  name?: string
  imageUrl?: string
  activity: 'green' | 'red' | 'gray'
  size?: 'xs' | 'sm' | 'md' | 'lg'
}

const AvatarActivity: React.FC<AvatarActivityProps> = (
  props: AvatarActivityProps
) => {
  const { name, imageUrl, activity, size } = props

  return (
    <Avatar name={name ?? ''} src={imageUrl ?? 'null'} size={size ?? 'md'}>
      {activity !== 'gray' && (
        <AvatarBadge borderWidth={'1px'} boxSize="0.90em" bg={activity} />
      )}
    </Avatar>
  )
}

export default AvatarActivity
